import { render, staticRenderFns } from "./course.vue?vue&type=template&id=a418c858&scoped=true&"
import script from "./course.vue?vue&type=script&lang=js&"
export * from "./course.vue?vue&type=script&lang=js&"
import style0 from "./course.vue?vue&type=style&index=0&id=a418c858&prod&scoped=true&lang=css&"
import style1 from "./course.vue?vue&type=style&index=1&id=a418c858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a418c858",
  null
  
)

export default component.exports